import URI from 'urijs';
import {ajaxAuthed, API_BASE} from "./common";

export function getStatusReport$(subroute) {
  return ({ id, sortby, filterby, from, to, search } = {}) => {
    let url = URI.joinPaths(API_BASE, 'reports', subroute);
    url.query(URI.buildQuery({ projectid: id, filterby: filterby, filterstart: from, filterend: to, q: search }));
    return ajaxAuthed({ url: url.toString() });
  };
}

export function getCalendarReport$(subroute) {
  return ({ id, sortby, filterby, from, to, status, search } = {}) => {
    let url = URI.joinPaths(API_BASE, 'reports', subroute, 'calendar');
    url.query(URI.buildQuery({ projectid: id, data: sortby, filterby: filterby, filterstart: from, filterend: to, status, q: search }));
    return ajaxAuthed({ url: url.toString() });
  }
}

export function getDetailsReport$(subroute) {
  return ({ id } = {}) => {
    let url = URI.joinPaths(API_BASE, 'reports', subroute, 'details');
    if (id) url.query(URI.buildQuery({ projectid: id }));
    return ajaxAuthed({ url: url.toString() });
  };
}

export function getUpcomingBidDetailsReportDownload$() {
  let url = URI.joinPaths(API_BASE, 'reports', 'bids', 'upcoming', 'details', 'download');
  return ajaxAuthed({ url: url.toString() });
}

export const getBidStatusReports$ = getStatusReport$('bids');
export const getProjectStatusReports$ = getStatusReport$('projects');
export const getProjectRfiStatusReports$ = getStatusReport$('project-rfis');
export const getSubmittalStatusReports$ = getStatusReport$('submittals');
export const getTaskStatusReports$ = getStatusReport$('tasks');
export const getPunchStatusReports$ = getStatusReport$('punches');
export const getDailyLogStatusReports$ = getStatusReport$('daily-logs');

export const getBidCalendarReports$ = getCalendarReport$('bids');
export const getProjectCalendarReports$ = getCalendarReport$('projects');
export const getProjectRfiCalendarReports$ = getCalendarReport$('project-rfis');
export const getSubmittalCalendarReports$ = getCalendarReport$('submittals');
export const getTaskCalendarReports$ = getCalendarReport$('tasks');
export const getPunchCalendarReports$ = getCalendarReport$('punches');
export const getDailyLogCalendarReports$ = getCalendarReport$('daily-logs');

export const getUpcomingBidDetailsReports$ = getDetailsReport$('bids/upcoming');
export const getProjectRfiDetailsReports$ = getDetailsReport$('project-rfis');
export const getSubmittalDetailsReports$ = getDetailsReport$('submittals');
export const getTaskDetailsReports$ = getDetailsReport$('tasks');
export const getDailyLogDetailsReports$ = getDetailsReport$('daily-logs');
export const getMeetingMinutesDetailsReports$ = getDetailsReport$('meeting-minutes');



// WEBPACK FOOTER //
// ./src/services/reports.js